import { z } from 'zod';

// ---------------------------------------------------------------------------
// Catalog item shapes
// ---------------------------------------------------------------------------

export const CausaInterferenciaSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  descripcion: z.string().nullable(),
});

export const TipoEventoSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  descripcion: z.string().nullable(),
});

export const EstadoEventoSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  descripcion: z.string().nullable(),
});

export type CausaInterferenciaItem = z.infer<typeof CausaInterferenciaSchema>;
export type TipoEventoItem = z.infer<typeof TipoEventoSchema>;
export type EstadoEventoItem = z.infer<typeof EstadoEventoSchema>;

// ---------------------------------------------------------------------------
// Catalogs response (single endpoint for all three)
// ---------------------------------------------------------------------------

export const InterferenciaCatalogosSchema = z.object({
  causas: z.array(CausaInterferenciaSchema),
  tipos: z.array(TipoEventoSchema),
  estados: z.array(EstadoEventoSchema),
});

export type InterferenciaCatalogos = z.infer<typeof InterferenciaCatalogosSchema>;

// ---------------------------------------------------------------------------
// Create / Update
// ---------------------------------------------------------------------------

export const CreateEventoSchema = z.object({
  otId: z.number().int().positive(),
  descripcion: z.string().min(1, 'La descripcion es obligatoria').max(4000),
  accionInmediata: z.string().max(4000).optional(),
  fechaEvento: z.string().min(1, 'La fecha del evento es obligatoria'), // ISO date string
  causaInterferenciaId: z.number().int().positive('Seleccione una causa'),
  tipoEventoId: z.number().int().positive('Seleccione un tipo de evento'),
  estadoEventoId: z.number().int().positive().default(1), // default "Abierto"
  observaciones: z.string().max(4000).optional(),
});

export const UpdateEventoSchema = z.object({
  descripcion: z.string().min(1).max(4000).optional(),
  accionInmediata: z.string().max(4000).nullable().optional(),
  fechaEvento: z.string().optional(),
  causaInterferenciaId: z.number().int().positive().optional(),
  tipoEventoId: z.number().int().positive().optional(),
  estadoEventoId: z.number().int().positive().optional(),
  observaciones: z.string().max(4000).nullable().optional(),
});

export type CreateEventoInput = z.infer<typeof CreateEventoSchema>;
export type UpdateEventoInput = z.infer<typeof UpdateEventoSchema>;

// ---------------------------------------------------------------------------
// Response item (list endpoint)
// ---------------------------------------------------------------------------

export interface EventoListItem {
  id: number;
  otId: number;
  descripcion: string;
  accionInmediata: string | null;
  fechaEvento: string;
  causaInterferencia: CausaInterferenciaItem;
  tipoEvento: TipoEventoItem;
  estadoEvento: EstadoEventoItem;
  observaciones: string | null;
  creadoPor: number | null;
  createdAt: string;
  updatedAt: string;
}
